export const NAV = {
  brand: "nav-brand",
  search: "nav-search",
  map: "nav-map",
  publish: "nav-publish-cta",
  login: "nav-login",
  register: "nav-register",
  dashboard: "nav-dashboard",
  logout: "nav-logout",
  favorites: "nav-favorites",
};

export const HOME = {
  hero: "home-hero",
  heroCtaSearch: "hero-cta-search",
  heroCtaPublish: "hero-cta-publish",
  countryTabs: "home-country-tabs",
  featuredGrid: "home-featured-grid",
};

export const SEARCH = {
  filterBar: "search-filter-bar",
  countrySelect: "filter-country",
  typeSelect: "filter-type",
  propertyTypeSelect: "filter-property-type",
  citySelect: "filter-city",
  minPrice: "filter-min-price",
  maxPrice: "filter-max-price",
  rooms: "filter-rooms",
  searchInput: "filter-query",
  submitButton: "search-submit-button",
  resetButton: "search-reset-button",
  resultsCount: "search-results-count",
  resultsGrid: "search-results-grid",
};

export const CARD = {
  link: "property-card-link",
  title: "property-card-title",
  price: "property-card-price",
  city: "property-card-city",
  boostedBadge: "property-card-boosted",
  proBadge: "property-card-pro-badge",
  favBtn: "property-card-fav",
};

export const DETAIL = {
  container: "listing-detail-container",
  title: "listing-detail-title",
  price: "listing-detail-price",
  gallery: "listing-detail-gallery",
  description: "listing-detail-description",
  amenities: "listing-detail-amenities",
  contactBtn: "agent-contact-button",
  agentCard: "listing-detail-agent",
  messageInput: "listing-detail-message-input",
  sendMessageBtn: "listing-detail-send-message",
};

export const AUTH = {
  loginEmail: "login-email",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  registerName: "register-name",
  registerEmail: "register-email",
  registerPassword: "register-password",
  registerRole: "register-role",
  registerCountry: "register-country",
  registerCompany: "register-company",
  registerSubmit: "register-submit",
};

export const DASH = {
  container: "dashboard-container",
  statTotal: "stat-total",
  statActive: "stat-active",
  statBoosted: "stat-boosted",
  statFavorites: "stat-favorites",
  statMessages: "stat-messages",
  newListingBtn: "dashboard-new-listing",
  listingsTable: "dashboard-listings-table",
  editBtn: "dashboard-edit-listing",
  deleteBtn: "dashboard-delete-listing",
  boostBtn: "dashboard-boost-listing",
};

export const NEW_LISTING = {
  country: "new-listing-country",
  type: "new-listing-type",
  propertyType: "new-listing-property-type",
  title: "new-listing-title",
  description: "new-listing-description",
  price: "new-listing-price",
  surface: "new-listing-surface",
  rooms: "new-listing-rooms",
  bathrooms: "new-listing-bathrooms",
  city: "new-listing-city",
  neighborhood: "new-listing-neighborhood",
  photos: "new-listing-photos",
  amenities: "new-listing-amenities",
  submit: "new-listing-submit",
};
